module.exports = __webpack_public_path__ + "202408221624/img/home_summer_1.985a8e5f.png";